import React, { useEffect, useState } from "react";
import {
  FaEdit,
  FaEye,
  FaExclamationTriangle,
  FaPercent  ,
  FaCreditCard,
} from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import FiltroClientes from "./FiltroClientes";
import DescargarFormulario from "../../../views/DescargarFormulario";
import VerClientes from "./VerClientes";
import EditarCliente from "./EditarCliente";
import CambiarEstadoTarjetas from "./CambiarEstadoTarjetas";
import InactivarPines from "./InactivarPines";
import EliminarDescuentos from "./EliminarDescuentos";
import useEscClose from "../../useEscClose";
// import { authHeaders } from '../../../utils/auth';
import { appFetchJson } from "../../../utils/http";
import { shouldRunOnce } from "../../../utils/devOnce"; // ✅ anti-doble-carga en dev
import { hasScope } from "../../../utils/auth";




const DatosClientes = () => {

  // ===== Scopes Datos del Cliente =====
const canViewCliente = hasScope("datos del cliente:view");
const canEditCliente = hasScope("datos del cliente:update");

const canDescuentos = hasScope("datos del cliente:descuentos");
const canTarjetas = hasScope("datos del cliente:tarjetas");
const canPines = hasScope("datos del cliente:pines");
const canFiltro = hasScope("datos del cliente:filtro");

  const [clientes, setClientes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  useEscClose(() => {
    setMostrarFiltros(false);
    document.activeElement?.blur();
  }, mostrarFiltros);
  const [filtros, setFiltros] = useState({});
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [clientesFiltrados, setClientesFiltrados] = useState([]);

  const [paginaActual, setPaginaActual] = useState(1);
  const [clientesPorPagina, setClientesPorPagina] = useState(30);
  const [totalClientesBackend, setTotalClientesBackend] = useState(0);

  const [detalleId, setDetalleId] = useState(null);
  useEscClose(() => {
    setDetalleId(null);
    document.activeElement?.blur();
  }, detalleId != null);

  // Editar clientes
  const [showEdit, setShowEdit] = useState(false);
  const [codigoEdit, setCodigoEdit] = useState(null);
  useEscClose(() => {
    setShowEdit(false);
    document.activeElement?.blur();
  }, showEdit);

  // Cambiar estado de Tarjeta
  const [showCambiarTarjeta, setShowCambiarTarjeta] = useState(false);
  const [clienteParaTarjeta, setClienteParaTarjeta] = useState(null);
  useEscClose(() => {
    setShowCambiarTarjeta(false);
    document.activeElement?.blur();
  }, showCambiarTarjeta);
  // Inactivar Pines
  const [showInactivarPines, setShowInactivarPines] = useState(false);
  const [clientePines, setClientePines] = useState(null);
  useEscClose(() => {
    setShowInactivarPines(false);
    document.activeElement?.blur();
  }, showInactivarPines);
  // Eliminar descuentos
  const [showEliminar, setShowEliminar] = useState(false);
  const [clienteEliminar, setClienteEliminar] = useState(null);
  useEscClose(() => {
    setShowEliminar(false);
    document.activeElement?.blur();
  }, showEliminar);

  // Señala si estamos en modo "unión OR" (paginación local)
  const [localPaginar, setLocalPaginar] = useState(false);

  const hasActiveFilters = (f) => {
    if (!f) return false;
    if ((f.codigosCliente?.length || 0) > 0) return true;
    if ((f.codigosExtra?.length || 0) > 0) return true;
    if ((f.nombresObjs?.length || 0) > 0) return true;
    if ((f.documentosObjs?.length || 0) > 0) return true;
    if (typeof f.nombre === "string" && f.nombre.trim()) return true;
    if (typeof f.documento === "string" && f.documento.trim()) return true;
    if (f.codigo != null && String(f.codigo).trim()) return true;
    if (f.grupoId != null || (f.grupoIds?.length || 0) > 0) return true; // ✅
    if (f.estadoId !== undefined && f.estadoId !== "") return true;
    return false;
  };

  // -------- helpers fetch ----------
  const buildParams = (opt = {}) => {
    const p = new URLSearchParams();
    if (opt.page !== undefined) p.append("page", opt.page);
    if (opt.size !== undefined) p.append("size", opt.size);
    if (opt.nombre) p.append("nombre", opt.nombre);
    if (opt.documento) p.append("documento", opt.documento);
    if (opt.codigo) p.append("codigo", opt.codigo);
    if (opt.grupoId != null) p.append("grupoId", opt.grupoId);
    if (opt.estadoId !== undefined && opt.estadoId !== "") {
      p.append("estadoId", opt.estadoId);
      p.append("estado.id", opt.estadoId);
    }
    return p;
  };

  const fetchList = async (opt = {}) => {
    const p = buildParams(opt);
    // Usamos el wrapper que maneja 401/403 y parsea JSON.
    const data = await appFetchJson(
      `${apiRoutes.clientes.list}?${p.toString()}`,
    );
    return data;
  };

  // Trae TODAS las páginas…
  const fetchAllList = async (opt = {}, pageSize = 500, maxPages = 50) => {
    let page = 0;
    const acc = [];

    const first = await fetchList({ ...opt, page, size: pageSize });
    const firstItems = first.items || [];
    acc.push(...firstItems);

    const total = first.totalElements ?? null;
    const totalPagesByServer =
      total != null ? Math.ceil(total / pageSize) : null;

    const pagesToFetch =
      totalPagesByServer != null
        ? Math.min(maxPages, totalPagesByServer)
        : maxPages;

    for (page = 1; page < pagesToFetch; page++) {
      const data = await fetchList({ ...opt, page, size: pageSize });
      const items = data.items || [];
      acc.push(...items);
      if (totalPagesByServer == null && items.length < pageSize) break;
    }

    return acc;
  };

  // ------------------- FETCH CLIENTES -------------------
  const fetchClientes = async (
    pagina = paginaActual,
    tamaño = clientesPorPagina,
    filtrosAplicados = filtros,
  ) => {
    setCargando(true);

    const codigosCliente = Array.isArray(filtrosAplicados?.codigosCliente)
      ? filtrosAplicados.codigosCliente
      : [];
    const codigosExtra = Array.isArray(filtrosAplicados?.codigosExtra)
      ? filtrosAplicados.codigosExtra
      : [];
    const codigos = [
      ...new Set([...codigosCliente, ...codigosExtra].filter(Boolean)),
    ];

    const grupoIds = Array.isArray(filtrosAplicados?.grupoIds)
      ? filtrosAplicados.grupoIds.filter((g) => g != null)
      : [];
    const singleGroupId =
      filtrosAplicados?.grupoId != null
        ? filtrosAplicados.grupoId
        : grupoIds.length === 1
          ? grupoIds[0]
          : null;

    const hasMultipleGroups = grupoIds.length > 1;
    const hasSingleGroup = singleGroupId != null;
    const hasAnyGroup = hasSingleGroup || hasMultipleGroups;

    const hasText = Boolean(
      (filtrosAplicados?.nombre && filtrosAplicados.nombre.trim()) ||
        (filtrosAplicados?.documento && filtrosAplicados.documento.trim()),
    );
    const hasEstado =
      filtrosAplicados?.estadoId !== undefined &&
      filtrosAplicados.estadoId !== "";

    const scope = {};
    if (hasSingleGroup) scope.grupoId = singleGroupId;
    if (hasEstado) scope.estadoId = filtrosAplicados.estadoId;

    const groupsToQuery = hasMultipleGroups
      ? grupoIds
      : hasSingleGroup
        ? [singleGroupId]
        : [null];

    if (!hasText && codigos.length === 0) {
      if (hasMultipleGroups) {
        setLocalPaginar(true);
        try {
          const prom = groupsToQuery
            .filter((gid) => gid != null)
            .map((gid) =>
              fetchAllList({
                grupoId: gid,
                ...(hasEstado ? { estadoId: filtrosAplicados.estadoId } : {}),
              }),
            );
          const listas = await Promise.all(prom);
          const flat = listas.flat();

          const seen = new Set();
          const unicos = flat.filter((row) => {
            const key = row.id ?? row.clienteId ?? row.codigo;
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
          });

          setClientes(unicos);
          setClientesFiltrados(unicos);
          setTotalClientesBackend(unicos.length);
        } catch (err) {
          console.error("Error al obtener clientes (multi-grupo):", err);
          setClientes([]);
          setClientesFiltrados([]);
          setTotalClientesBackend(0);
        } finally {
          setCargando(false);
        }
        return;
      }

      setLocalPaginar(false);
      try {
        const data = await fetchList({
          page: pagina - 1,
          size: tamaño,
          ...scope,
        });
        const resultados = data.items || [];
        setClientes(resultados);
        setClientesFiltrados(resultados);
        setTotalClientesBackend(data.totalElements || 0);
      } catch (err) {
        console.error("Error al obtener clientes:", err);
        setClientes([]);
        setClientesFiltrados([]);
        setTotalClientesBackend(0);
      } finally {
        setCargando(false);
      }
      return;
    }

    setLocalPaginar(true);
    try {
      const promises = [];

      const fetchUnoCodigo = async (codigo, gid) => {
        const data = await fetchList({
          page: 0,
          size: 1,
          codigo,
          ...(gid != null ? { grupoId: gid } : {}),
          ...(hasEstado ? { estadoId: filtrosAplicados.estadoId } : {}),
        });
        return data.items || [];
      };
      if (codigos.length > 0) {
        for (const c of codigos) {
          for (const gid of hasAnyGroup ? groupsToQuery : [null]) {
            promises.push(fetchUnoCodigo(c, gid));
          }
        }
      }

      if (hasText) {
        for (const gid of hasAnyGroup ? groupsToQuery : [null]) {
          promises.push(
            fetchAllList({
              nombre: filtrosAplicados.nombre,
              documento: filtrosAplicados.documento,
              ...(gid != null ? { grupoId: gid } : {}),
              ...(hasEstado ? { estadoId: filtrosAplicados.estadoId } : {}),
            }),
          );
        }
      }

      const listas = await Promise.all(promises);
      const flat = listas.flat();

      const seen = new Set();
      const unicos = flat.filter((row) => {
        const key = row.id ?? row.clienteId ?? row.codigo;
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      setClientes(unicos);
      setClientesFiltrados(unicos);
      setTotalClientesBackend(unicos.length);
    } catch (err) {
      console.error("Error en unión OR:", err);
      setClientes([]);
      setClientesFiltrados([]);
      setTotalClientesBackend(0);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    // ✅ evita doble carga en dev por StrictMode
    if (!shouldRunOnce("DatosClientes:init")) return;
    fetchClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------------- FILTROS -------------------
  const toggleFiltros = () => setMostrarFiltros(!mostrarFiltros);

  const limpiarSeleccion = () => {
    setFiltros({});
    setClienteSeleccionado(null);
    setPaginaActual(1);
    fetchClientes(1, clientesPorPagina, {});
  };

  const aplicarSnapshotEnVivo = (snapshot) => {
    const snap = hasActiveFilters(snapshot) ? snapshot : {};
    setFiltros(snap);
    setClienteSeleccionado(null);
    setPaginaActual(1);
    fetchClientes(1, clientesPorPagina, snap);
  };

  const cambiarPagina = (num) => {
    const totalPaginas =
      Math.ceil(totalClientesBackend / clientesPorPagina) || 1;
    if (num < 1) num = 1;
    if (num > totalPaginas) num = totalPaginas;
    setPaginaActual(num);
    if (!localPaginar) {
      fetchClientes(num, clientesPorPagina, filtros);
    }
  };

  const manejarCambioCantidad = (e) => {
    const nuevaCantidad = Number(e.target.value);
    setClientesPorPagina(nuevaCantidad);
    setPaginaActual(1);
    fetchClientes(1, nuevaCantidad, filtros);
  };

  // ------------------- PAGINACION -------------------
  const totalPaginas = Math.ceil(totalClientesBackend / clientesPorPagina) || 1;
  const startIndex = (paginaActual - 1) * clientesPorPagina;
  const endIndex = Math.min(
    startIndex + clientesPorPagina,
    totalClientesBackend,
  );

  const datosAMostrar = clienteSeleccionado
    ? [clienteSeleccionado]
    : localPaginar
      ? clientesFiltrados.slice(startIndex, endIndex)
      : clientesFiltrados;

  const indiceInicio = totalClientesBackend === 0 ? 0 : startIndex + 1;
  const indiceFin = endIndex;

  // ------------------- RENDER -------------------
  return (
    <div className="page">
      <h1 className="page-title">📋 Datos de Clientes</h1>
      <div className="toolbar">
        <div className="inline-flex items-center gap-2">
          <button
            onClick={toggleFiltros}
            className="btn-fil"
            style={{ visibility: canFiltro ? "visible" : "hidden" }}
          >
            {mostrarFiltros ? "Ocultar Filtros" : "Ver Filtros"}
          </button>

          {hasActiveFilters(filtros) && canFiltro && (
            <button onClick={limpiarSeleccion} className="btn-fil ml-2">
              Limpiar Selección
            </button>
          )}
        </div>
        <div className="flex items-center">
          <DescargarFormulario
            clientes={clientes}
            clientesFiltrados={clientes}
            exportarPaginaActual={true}
          />
        </div>
      </div>

      {canFiltro && mostrarFiltros && (
        <FiltroClientes
          initialFilters={filtros}
          onSubmit={(items, filtrosAplicados) => {
            const snap = filtrosAplicados || {};
            setFiltros(snap);
            setClienteSeleccionado(null);
            setPaginaActual(1);
            setMostrarFiltros(false);
            fetchClientes(1, clientesPorPagina, snap);
          }}
          onChangeFilters={aplicarSnapshotEnVivo}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <div className="control-block">
        <label htmlFor="cantidadPorPagina" className="label-strong">
          Mostrar por página:
        </label>
        <select
          id="cantidadPorPagina"
          value={clientesPorPagina}
          onChange={manejarCambioCantidad}
          disabled={!!clienteSeleccionado}
          className="select"
        >
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>

      {cargando ? (
        <div className="loading-text">Cargando clientes...</div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="table-card">
              <thead className="table-head">
                <tr>
                  <th className="cell text-left">Cód. Cliente</th>
                  <th className="cell text-left">Nombre</th>
                  <th className="cell text-left">Documento</th>
                  <th className="cell text-left">Estado</th>
                  <th className="cell-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                {datosAMostrar.map((cliente, idx) => (
                  <tr
                    key={`${cliente.id ?? cliente.codigo ?? idx}-${idx}`}
                    className={idx % 2 === 0 ? "row-alt" : "bg-white"}
                  >
                    <td className="cell">{cliente.codigo}</td>
                    <td className="cell">{cliente.nombre}</td>
                    <td className="cell">{cliente.documento}</td>
                    <td className="cell">{cliente.estadoNombre}</td>
                    <td className="cell-center space-x-2">

                    {canViewCliente && (
                      <button
                        className="icon-btn"
                        title="Visualizar"
                        onClick={() => {
                          const id = cliente.id ?? cliente.clienteId ?? null;
                          if (id) setDetalleId(id);
                        }}
                      >
                        <FaEye />
                      </button>
                    )}

                    {canEditCliente && (
                      <button
                        className="icon-btn"
                        title="Editar"
                        onClick={() => {
                          setCodigoEdit(cliente.id);
                          setShowEdit(true);
                        }}
                      >
                        <FaEdit />
                      </button>
                    )}

                    {canDescuentos && (
                      <button
                        className="icon-btn"
                        title="Descuentos"
                        onClick={() => {
                          setClienteEliminar(cliente);
                          setShowEliminar(true);
                        }}
                      >
                        <FaPercent />
                      </button>
                    )}

                    {canTarjetas && (
                      <button
                        className="icon-btn"
                        title="Cambiar Estado de Tarjetas"
                        onClick={() => {
                          setClienteParaTarjeta(cliente);
                          setShowCambiarTarjeta(true);
                        }}
                      >
                        <FaCreditCard />
                      </button>
                    )}

                    {canPines && (
                      <button
                        className="icon-btn"
                        title="Inactivar Pines"
                        onClick={() => {
                          setClientePines(cliente);
                          setShowInactivarPines(true);
                        }}
                      >
                        <FaExclamationTriangle />
                      </button>
                    )}

                  </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-4 text-sm text-gray-600">
            {`${totalClientesBackend.toLocaleString("es-ES")} item${totalClientesBackend !== 1 ? "s" : ""} encontrados, mostrando de ${indiceInicio} a ${indiceFin}.`}
          </div>
          {!clienteSeleccionado && (
            <nav className="pager">
              <button
                onClick={() => cambiarPagina(1)}
                disabled={paginaActual === 1}
                className={paginaActual === 1 ? "pager-off" : "pager-btn"}
              >
                Primera
              </button>
              <button
                onClick={() => cambiarPagina(paginaActual - 1)}
                disabled={paginaActual === 1}
                className={paginaActual === 1 ? "pager-off" : "pager-btn"}
              >
                Anterior
              </button>
              {[...Array(totalPaginas)].map((_, i) => {
                const num = i + 1;
                if (
                  num === 1 ||
                  num === totalPaginas ||
                  (num >= paginaActual - 2 && num <= paginaActual + 2)
                ) {
                  return (
                    <button
                      key={num}
                      onClick={() => cambiarPagina(num)}
                      className={
                        paginaActual === num ? "pager-active" : "pager-btn"
                      }
                    >
                      {num}
                    </button>
                  );
                }
                if (num === paginaActual - 3 || num === paginaActual + 3) {
                  return (
                    <span key={num} className="px-2 py-1">
                      …
                    </span>
                  );
                }
                return null;
              })}
              <button
                onClick={() => cambiarPagina(paginaActual + 1)}
                disabled={paginaActual === totalPaginas}
                className={
                  paginaActual === totalPaginas ? "pager-off" : "pager-btn"
                }
              >
                Próxima
              </button>
              <button
                onClick={() => cambiarPagina(totalPaginas)}
                disabled={paginaActual === totalPaginas}
                className={
                  paginaActual === totalPaginas ? "pager-off" : "pager-btn"
                }
              >
                Última
              </button>
            </nav>
          )}
        </>
      )}

      {/* ===== Modal de VistaClientes ===== */}
      {detalleId != null && (
        <div className="modal-backdrop">
          <div className="modal-panel-lg">
            <button
              onClick={() => setDetalleId(null)}
              className="modal-close-x"
              title="Cerrar"
            >
              &times;
            </button>
            <VerClientes
              idCliente={detalleId}
              onClose={() => setDetalleId(null)}
            />
          </div>
        </div>
      )}

      {/* ===== Modal de EditClientes ===== */}
      {showEdit && (
        <EditarCliente
          codigo={codigoEdit}
          onClose={() => setShowEdit(false)}
          onSaved={() => {
            setShowEdit(false);
            fetchClientes(paginaActual, clientesPorPagina, filtros);
          }}
        />
      )}

      {/* ===== Modal de CambiarTarjeta ===== */}
      {showCambiarTarjeta && clienteParaTarjeta && (
        <CambiarEstadoTarjetas
          cliente={clienteParaTarjeta}
          onClose={() => {
            setShowCambiarTarjeta(false);
            setClienteParaTarjeta(null);
          }}
          onSaved={({ total, seleccionadas, estadoNuevo }) => {
            console.log(
              "Actualizadas:",
              seleccionadas,
              "de",
              total,
              "a",
              estadoNuevo,
            );
          }}
        />
      )}

      {showInactivarPines && clientePines && (
        <InactivarPines
          cliente={clientePines}
          onClose={() => {
            setShowInactivarPines(false);
            setClientePines(null);
          }}
          onSaved={({ total, seleccionadas }) => {
            console.log(`Inactivados ${seleccionadas} de ${total} pines`);
          }}
        />
      )}

      {/* Eliminar descuentos modal */}
      {showEliminar && clienteEliminar && (
        <EliminarDescuentos
          cliente={clienteEliminar}
          onClose={() => setShowEliminar(false)}
          onSaved={({ total, seleccionadas }) => {
            console.log("Eliminados", seleccionadas, "de", total);
            setShowEliminar(false);
          }}
        />
      )}
    </div>
  );
};

export default DatosClientes;
